import { EBrand } from '@bonhams1793/bonhams-typescript'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import {
  EActiveLanguages,
  LocaleString,
  SmartlingAttributes,
  stripLocaleFromPath,
} from '@nx/smartling'
import { getTranslate } from '@nx/translations'

import {
  StyledBody,
  StyledButton,
  TranslationBannerContainer,
  TranslationBannerInner,
} from './TranslationsLanguageDetectBanner.styles'
import translate from './TranslationsLanguageDetectBanner.translate.json'

const { text } = getTranslate(translate)

export function TranslationsLanguageDetectBanner({
  acceptLanguage,
  brand,
}: TranslationsLanguageDetectBannerProps) {
  const [visible, setVisible] = useState(false)
  const router = useRouter()

  const baseLanguage =
    brand === 'cornette' ? LocaleString.french : LocaleString.english

  const localeFolderPath =
    acceptLanguage === baseLanguage ? '' : `/${acceptLanguage}`
  const currentPath = stripLocaleFromPath(router.asPath)
  const redirectPath = `${localeFolderPath}${currentPath}`
  const localeArray = Object.values(LocaleString)

  function handleClick() {
    if (typeof window !== 'undefined') {
      window.location.assign(redirectPath)
    }
  }

  useEffect(() => {
    const currentLocale = window.location.href
      .split('/')[3]
      .toLowerCase() as LocaleString

    if (
      (localeArray.includes(currentLocale) &&
        currentLocale !== acceptLanguage.toLowerCase()) ||
      (!localeArray.includes(currentLocale) && acceptLanguage !== baseLanguage)
    ) {
      setVisible(true)
    } else {
      setVisible(false)
    }
  }, [acceptLanguage, localeArray, baseLanguage])

  return visible ? (
    <TranslationBannerContainer {...SmartlingAttributes.noTranslate}>
      <TranslationBannerInner>
        <StyledBody $level="S">{text(`body-${acceptLanguage}`)}</StyledBody>
        <StyledButton onClick={() => handleClick()} size="S">
          {text(`button-${acceptLanguage}`)}
        </StyledButton>
      </TranslationBannerInner>
    </TranslationBannerContainer>
  ) : null
}

interface TranslationsLanguageDetectBannerProps {
  acceptLanguage: EActiveLanguages
  brand: EBrand
}
